import fondo from '../img/fond.webp'
import img from '../img/SitioWeb.png'
import '../css/secciones.css'

const SitioWeb = () => {
    return (
        <section className='seccionContainer' id='sitioWeb'>
            <img src={fondo} className='fondo' alt='fondo' />
            <div className='cardAnimation'>
                <h2 className='title'>Sitio Web</h2>
            </div>
            <div className='dataContainer'>
                <img src={img} alt='sitio web' style={{ zIndex: 50 }} />
                <div className='parrafoContainer'>
                    <p className='parrafo'>
                        Tu presencia digital empieza aquí.
                        Un sitio web profesional permite que tu empresa esté visible en los buscadores 
                        y al alcance de tus potenciales clientes. Es la carta de presentación ideal para
                         mostrar quién sos, qué hacés y cómo contactarte. Diseño único, información clara 
                         y tecnología de punta para posicionarte en Internet.

                    </p>
                    <a className='info' href='https://wa.me/5491126134318?text=Hola me gustaria consultar por un Sitio Web.' target='blank' ><button>
    <span>Más información</span>
  </button></a>
                </div>
            </div>
        </section>
    )
}

export default SitioWeb